import React from 'react';
import './Vault.scss';
import * as _ from "lodash";
import {humanFileSize} from "../../utils/helpers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Tooltip from "@material-ui/core/Tooltip";
import routes from "../../utils/api-client";
import * as moment from "moment";
import {ADVISOR, KEYHOLDER, OWNER} from "../../config/constants";


function VaultDetails(props) {

  const vault = props.vault;
  const canDownloadDocuments = vault.role === OWNER || vault.role === ADVISOR || (vault.status === 'UNLOCKED' && !vault.accessDelayed  && vault.role === KEYHOLDER);

  return (
    <div className="vault-details-container m-auto">
      <div className="mt-8">
        <p className="text-lg md:text-xl"><b className="text-xl md:medium-text-xl">{ vault.documents.length }</b> Document{ vault.documents.length !== 1 ? 's' : '' } Stored</p>
        <div className="sm:mt-3 vault-form-content-container text-sm sm:text-base">

          {
            vault.documents.length ?
              <>
                <div className="vault-detail-header-row flex text-sm">
                  <p className="documents-name-field font-bold hidden sm:block">File Name</p>
                  <p className="font-bold hidden sm:block">Uploaded</p>
                </div>
                {
                  _.map(vault.documents, (document, index) =>
                    <div key={index}
                         className={`vault-detail-table-row flex flex-col sm:flex-row sm:items-center ${canDownloadDocuments ? 'cursor-pointer text-primary': 'no-pointer-events'}`}
                         onClick={() => routes.downloadVaultFile(vault.id, document.name)}>
                      <p className="documents-name-field">
                        { document.name }
                        <span className="text-xs md:text-sm text-grey ml-2">({ humanFileSize(document.size) })</span>
                      </p>
                      <div className="flex items-center flex-1 justify-between">
                        <p className="text-grey mt-2 sm:mt-0 text-sm">{ moment(document.updated).format('L LT') }</p>
                        {
                          _.includes(["PENDING", "LOCKED"], vault.status) || vault.accessDelayed ?
                            <Tooltip enterTouchDelay={50} title="This document is not available to Keyholders until an access request has been approved.">
                              <div>
                                <FontAwesomeIcon icon="lock" className="cursor-pointer"/>
                              </div>
                            </Tooltip>
                            :
                            <Tooltip enterTouchDelay={50} title="The vault has been unlocked and this document is available to be download.">
                              <div>
                                <FontAwesomeIcon icon="lock-open" className="cursor-pointer"/>
                              </div>
                            </Tooltip>
                        }
                      </div>
                    </div>
                  )
                }
              </>
               :
              <div className="flex items-center warning-row">
                <FontAwesomeIcon icon="info-circle" size="lg" className="mr-2 text-warning warning-icon"/>
                <div className="flex-1">No Documents have been uploaded to this vault.</div>
              </div>
          }
        </div>
      </div>

      <div className="mt-8">
        <p className="text-lg md:text-xl"><b className="text-xl md:medium-text-xl">{ vault.keyholders.length }</b> Keyholder{ vault.keyholders.length !== 1 ? 's' : '' } </p>
        <div className="sm:mt-3 vault-form-content-container text-sm sm:text-base">
          {
            vault.keyholders.length ?
              <>
                <div className="vault-detail-header-row flex text-sm">
                  <p className="keyholder-name-text font-bold hidden sm:block">Name</p>
                  <p className="keyholder-email-text font-bold hidden sm:block">Email</p>
                </div>
                {
                  _.map(vault.keyholders, (user, index) =>
                    <>
                      {/* TODO: this is sloppy, find a way to combine*/}
                      <div key={index} className={`vault-detail-table-row flex flex-col sm:hidden`}>
                        <Tooltip title={user.name} enterTouchDelay={50}>
                          <div className="flex items-center sm:mt-0">
                            <span className="text-grey text-xs">Name: &nbsp;</span>
                            <p className="keyholder-name-text flex-1">{ user.name }</p>
                          </div>
                        </Tooltip>
                        <Tooltip title={user.email} enterTouchDelay={50}>
                          <div className="flex mt-1 items-center sm:mt-0">
                            <span className="text-grey text-xs">Email: &nbsp;</span>
                            <p className="keyholder-email-text flex-1">{ user.email }</p>
                          </div>
                        </Tooltip>
                      </div>
                      <div key={index} className={`vault-detail-table-row items-center hidden sm:flex`}>
                        <Tooltip title={user.name} enterTouchDelay={50}>
                          <p className="keyholder-name-text">{ user.name }</p>
                        </Tooltip>
                        <Tooltip title={user.email} enterTouchDelay={50}>
                          <p className="keyholder-email-text">{ user.email }</p>
                        </Tooltip>
                      </div>
                    </>
                  )
                }
              </>
              :
              <div className="flex items-center warning-row">
                <FontAwesomeIcon icon="info-circle" size="lg" className="mr-2 text-warning warning-icon"/>
                <div className="flex-1">No Keyholders have been chosen for this vault; <span className="font-bold ">only you have
                  access</span>.</div>
              </div>
          }
        </div>
      </div>

      <div className="mt-8">
        <p className="text-lg md:text-xl"><b className="text-xl md:medium-text-xl">{ vault.guardians.length }</b> Guardian{ vault.guardians.length !== 1 ? 's' : '' } </p>
        <div className="sm:mt-3 vault-form-content-container text-sm sm:text-base">
          {
            vault.guardians.length ?
              <>
                <div className="vault-detail-header-row flex text-sm">
                  <p className="keyholder-name-text font-bold hidden sm:block">Name</p>
                  <p className="font-bold keyholder-email-text hidden sm:block">Email</p>
                </div>
                {
                  _.map(vault.guardians, (user, index) =>
                    <>
                      {/* TODO: this is sloppy, find a way to combine*/}
                      <div key={index} className={`vault-detail-table-row flex flex-col sm:hidden`}>
                        <Tooltip title={user.name} enterTouchDelay={50}>
                          <div className="flex items-center">
                            <span className="text-grey text-xs">Name: &nbsp;</span>
                            <p className="keyholder-name-text flex-1">{ user.name }</p>
                          </div>
                        </Tooltip>
                        <Tooltip title={user.email} enterTouchDelay={50}>
                          <div className="flex mt-1 items-center">
                            <span className="text-grey text-xs">Email: &nbsp;</span>
                            <p className="keyholder-email-text flex-1">{ user.email }</p>
                          </div>
                        </Tooltip>
                      </div>
                      <div key={index} className={`vault-detail-table-row items-center hidden sm:flex`}>
                        <Tooltip title={user.name} enterTouchDelay={50}>
                          <p className="keyholder-name-text">{ user.name }</p>
                        </Tooltip>
                        <Tooltip title={user.email} enterTouchDelay={50}>
                          <p className="keyholder-email-text">{ user.email }</p>
                        </Tooltip>
                      </div>
                    </>
                  )
                }
              </>
              :
              <div className="flex items-center warning-row">
                <FontAwesomeIcon icon="exclamation-circle" size="lg" className="mr-2 text-alert warning-icon"/>
                <div className="flex-1">No guardians have been chosen for this vault. <span className="font-bold">Keyholder requests will be automatically approved.</span></div>
              </div>
          }
        </div>
      </div>
    </div>
  );
};

export default VaultDetails;

